import { Checkbox } from '@material-ui/core';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const ProjectTopComponent = ({ projectSetup, setProjectSetup }) => {

    const [projectStatus, setProjectStatus] = React.useState(projectSetup.projectStatus === "active" ? true : false);

    React.useEffect(() => {
        setProjectStatus(projectSetup.projectStatus === "active" ? true : false);
    }, [projectSetup]);

    const handleCheckboxClick = (e, status) => {

        let newProjectSetup = projectSetup;

        let newStatus = !status;

        if (newStatus === true) {

            newProjectSetup.projectStatus = "active";

        } else {

            newProjectSetup.projectStatus = "inactive";

        }

        setProjectSetup(newProjectSetup);

        setProjectStatus(!status);

    }


    return (
        <Row

            style={{
                alignItems: 'center',
                justifyContent: 'center',

            }}


        >

            <Col sm={1} />


            <label className='handwai-text-label-main'

                style={{ marginLeft: '15px' }}

            >Projektstatus</label> &nbsp; &nbsp;
            <div style={{ backgroundColor: "white" }}>
                <Checkbox color='grey'
                    checked={projectStatus} onClick={(e) => handleCheckboxClick(e, projectStatus)} />

            </div>

            <Col />

            <Col>
                <label className='handwai-text-label-main'>Projektname</label>
            </Col>
            <Col>
                <input className='handwai-text-input-normal' type='text'

                    value={projectSetup.projectName}
                    onChange={(e) => setProjectSetup({ ...projectSetup, projectName: e.target.value })}

                />
            </Col>

            <Col />

            <Col>
                <label className='handwai-text-label-main'>Auftrag-Nr.</label>
            </Col>

            <Col>
                <input className='handwai-text-input-normal' type='text'

                    value={projectSetup.customerIdentificator}
                    onChange={(e) => setProjectSetup({ ...projectSetup, customerIdentificator: e.target.value })}

                />
            </Col>


            <Col />

            <Col>
                <label className='handwai-text-label-main'>Referenz</label>
            </Col>

            <Col>
                <input className='handwai-text-input-normal' type='text'

                    value={projectSetup.customerReference}
                    onChange={(e) => setProjectSetup({ ...projectSetup, customerReference: e.target.value })}

                />
            </Col>

            <Col sm={1} />

        </Row>

    )
}

export default ProjectTopComponent;